export const EMPTY_VALUES = [null, undefined, ""];

export const NOOP_FUNCTION = () => {};
